import { render, staticRenderFns } from "./PtLandingPage.vue?vue&type=template&id=0d3b617b"
import script from "./PtLandingPage.vue?vue&type=script&lang=ts"
export * from "./PtLandingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports